interface DirectionsTransitProps {
  companyName: string;
  traffpublic: string;
}

export const DirectionsTransit = ({
  companyName,
  traffpublic,
}: DirectionsTransitProps) => {
  if (!traffpublic) return null;

  return (
    <section className="dr-section" aria-labelledby="dr-transit-title">
      <h2 id="dr-transit-title" className="dr-section__title">
        {`${companyName} 대중교통 안내`}
      </h2>
      <p className="dr-section__lede">
        지하철 · 버스로 찾아가시는 길 안내입니다.
      </p>
      <div className="dr-raw-text">{traffpublic}</div>
    </section>
  );
};
